export default "__VITE_ASSET__BPxV61C___"